function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useField } from '@formily/react';
import { DatePicker } from 'antd';
import cx from 'classnames';
import dayjs from 'dayjs';
import React from 'react';
import { useCssInJs, wrapReactionHook, useClear, useValues, useFill } from "../../hooks";
import { genFormDateRangeStyle } from "./styles";
var QUICK_RANGE_TYPES = ['全部', '今天', '本周', '上月', '本月'];
var DF_DISPLAY_FMT = 'YYYY-MM-DD';
var DF_VAL_FMT = 'YYYY-MM-DD HH:mm:ss';
var DF_PLACEHOLDERS = ['开始时间', '结束时间'];
var RangePicker = DatePicker.RangePicker;
export var FormDateRange = wrapReactionHook(function (props) {
  var _props$allowClear = props.allowClear,
    allowClear = _props$allowClear === void 0 ? true : _props$allowClear,
    _props$valueMap = props.valueMap,
    valueMap = _props$valueMap === void 0 ? {} : _props$valueMap,
    _props$autoFill = props.autoFill,
    autoFill = _props$autoFill === void 0 ? [] : _props$autoFill,
    _props$autoClear = props.autoClear,
    autoClear = _props$autoClear === void 0 ? [] : _props$autoClear,
    _props$quickActions = props.quickActions,
    quickActions = _props$quickActions === void 0 ? [] : _props$quickActions,
    _props$displayFormat = props.displayFormat,
    displayFormat = _props$displayFormat === void 0 ? DF_DISPLAY_FMT : _props$displayFormat,
    _props$valueFormat = props.valueFormat,
    valueFormat = _props$valueFormat === void 0 ? DF_VAL_FMT : _props$valueFormat,
    _props$placeholders = props.placeholders,
    placeholders = _props$placeholders === void 0 ? DF_PLACEHOLDERS : _props$placeholders,
    readOnly = props.readOnly,
    disabled = props.disabled;
  var _placeholders = _slicedToArray(placeholders, 2),
    startPh = _placeholders[0],
    endPh = _placeholders[1];
  var field = useField();
  var required = field.required;
  var clearField = useClear(autoClear);
  // map 解析
  var _useValues = useValues(valueMap),
    start = _useValues.start,
    end = _useValues.end;
  // map 回填
  var fill = useFill(autoFill);
  var prefix = 'form-range-item';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genFormDateRangeStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var title = field.title;
  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: cx(prefix, hashId)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("".concat(prefix, "-label"), hashId)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: cx("".concat(prefix, "-content"), hashId)
  }, /*#__PURE__*/React.createElement(RangePicker, {
    disabled: readOnly || disabled,
    presets: [{
      label: '昨天',
      value: [dayjs().add(-1, 'd'), dayjs()]
    }, {
      label: '近七天',
      value: [dayjs().add(-7, 'd'), dayjs()]
    }, {
      label: '近一个月',
      value: [dayjs().add(-1, 'month'), dayjs()]
    }],
    value: [start ? dayjs(start) : undefined, end ? dayjs(end) : undefined],
    format: displayFormat,
    allowClear: allowClear && !disabled
    // @ts-ignore
    ,
    placeholder: placeholders,
    onChange: function onChange(value) {
      var _value$, _value$2;
      clearField();
      fill({
        start: value === null || value === void 0 || (_value$ = value[0]) === null || _value$ === void 0 ? void 0 : _value$.format(valueFormat),
        end: value === null || value === void 0 || (_value$2 = value[1]) === null || _value$2 === void 0 ? void 0 : _value$2.format(valueFormat)
      });
    }
  }))));
});